import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/bulb.png'


const _withScopeId = n => (_pushScopeId("data-v-1d20db91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full relative w-full flex items-center justify-center" }
const _hoisted_2 = {
  key: 0,
  class: "_register _page-view"
}
const _hoisted_3 = {
  key: 0,
  class: "_page-view__title font-bold mb-1 text-neutral-700"
}
const _hoisted_4 = {
  key: 1,
  class: "_page-view__label mb-12 text-neutral-600"
}
const _hoisted_5 = { class: "_page-view__content" }
const _hoisted_6 = { class: "mb-12" }
const _hoisted_7 = { class: "input-group input--lg" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label" }, "Tên của bạn", -1))
const _hoisted_9 = { class: "mb-12" }
const _hoisted_10 = { class: "input-group input--lg" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label" }, "Cơ sở làm việc", -1))
const _hoisted_12 = { class: "mt-12" }
const _hoisted_13 = {
  key: 1,
  class: "_register _page-view"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_page-view__title font-bold mb-1 text-neutral-700" }, " Xin chào bạn ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_page-view__label mb-12 text-neutral-600" }, " Hãy thiết lập tài khoản của bạn để tiếp tục nhé ", -1))
const _hoisted_16 = { class: "_page-view__content" }
const _hoisted_17 = { class: "mb-12" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label" }, "Mật khẩu", -1))
const _hoisted_19 = ["type"]
const _hoisted_20 = { class: "absolute right-4 top-1/2 pt-1 cursor-pointer text-neutral-600" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z",
  fill: "currentColor"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z",
  fill: "currentColor"
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "error text-sienna-600"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label" }, "Xác nhận mật khẩu", -1))
const _hoisted_27 = ["type"]
const _hoisted_28 = { class: "absolute right-4 top-1/2 pt-1 cursor-pointer text-neutral-600" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z",
  fill: "currentColor"
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z",
  fill: "currentColor"
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 0,
  class: "error text-sienna-600"
}
const _hoisted_34 = { class: "mt-12" }
const _hoisted_35 = {
  key: 2,
  class: "_choose-center h-screen w-screen md-down:px-10 px-24 py-30"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_choose-center__title text-neutral-600 font-semibold mb-12" }, " Chọn Cơ Sở để tiếp tục ", -1))
const _hoisted_37 = { class: "_choose-center__list grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-10" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 font-medium text-center absolute bottom-10 w-full flex items-center gap-3 justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "",
      class: "w-6 h-6",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Tìm hiểu "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "font-semibold text-green-500",
      href: "https://wiki.luca.education/cac-ban-cap-nhat/website"
    }, "tính năng mới")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChooseCenterCard = _resolveComponent("ChooseCenterCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.step === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Xin chào bạn "))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Hãy xác nhận tài khoản của mình để tiếp tục nhé "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerData.full_name) = $event)),
                  class: "bg-white",
                  disabled: "",
                  placeholder: "Họ và tên của bạn",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.registerData.full_name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerData.org_name) = $event)),
                  class: "bg-white",
                  disabled: "",
                  placeholder: "Họ và tên của bạn",
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.registerData.org_name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "button-p btn--lg",
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
              }, " Xác Nhận ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.errorData.password ? 'error-input' : '', "input-group input--lg relative"])
              }, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerInfo.password) = $event)),
                  type: _ctx.typePassword,
                  class: "bg-white",
                  placeholder: "Mật khẩu của bạn"
                }, null, 8, _hoisted_19), [
                  [_vModelDynamic, _ctx.registerInfo.password]
                ]),
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.typePassword === 'text')
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 0,
                        "aria-hidden": "true",
                        class: "svg-inline--fa fa-eye fa-w-18",
                        "data-icon": "eye",
                        "data-prefix": "fas",
                        focusable: "false",
                        height: "16px",
                        role: "img",
                        viewBox: "0 0 576 512",
                        xmlns: "http://www.w3.org/2000/svg",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.typePassword = 'password'))
                      }, _hoisted_22))
                    : _createCommentVNode("", true),
                  (_ctx.typePassword === 'password')
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 1,
                        "aria-hidden": "true",
                        class: "svg-inline--fa fa-eye-slash fa-w-20",
                        "data-icon": "eye-slash",
                        "data-prefix": "fas",
                        focusable: "false",
                        height: "16px",
                        role: "img",
                        viewBox: "0 0 640 512",
                        xmlns: "http://www.w3.org/2000/svg",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.typePassword = 'text'))
                      }, _hoisted_24))
                    : _createCommentVNode("", true)
                ])
              ], 2),
              (_ctx.errorData.password)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.errorData.password), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass([
							_ctx.errorData.password_confirmation ? 'error-input' : ''
						, "input-group input--lg relative"])
              }, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.registerInfo.password_confirmation) = $event)),
                  type: _ctx.typePasswordConfirm,
                  class: "bg-white",
                  placeholder: "Xác nhận mật khẩu"
                }, null, 8, _hoisted_27), [
                  [_vModelDynamic, _ctx.registerInfo.password_confirmation]
                ]),
                _createElementVNode("div", _hoisted_28, [
                  (_ctx.typePasswordConfirm === 'text')
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 0,
                        "aria-hidden": "true",
                        class: "svg-inline--fa fa-eye fa-w-18",
                        "data-icon": "eye",
                        "data-prefix": "fas",
                        focusable: "false",
                        height: "16px",
                        role: "img",
                        viewBox: "0 0 576 512",
                        xmlns: "http://www.w3.org/2000/svg",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.typePasswordConfirm = 'password'))
                      }, _hoisted_30))
                    : _createCommentVNode("", true),
                  (_ctx.typePasswordConfirm === 'password')
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 1,
                        "aria-hidden": "true",
                        class: "svg-inline--fa fa-eye-slash fa-w-20",
                        "data-icon": "eye-slash",
                        "data-prefix": "fas",
                        focusable: "false",
                        height: "16px",
                        role: "img",
                        viewBox: "0 0 640 512",
                        xmlns: "http://www.w3.org/2000/svg",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.typePasswordConfirm = 'text'))
                      }, _hoisted_32))
                    : _createCommentVNode("", true)
                ])
              ], 2),
              (_ctx.errorData.password_confirmation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.errorData.password_confirmation), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", {
                class: "button-p btn--lg",
                type: "button",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onRegisterSubmit && _ctx.onRegisterSubmit(...args)))
              }, " Hoàn tất ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgs.filter((o) => o.is_active_org), (org) => {
              return (_openBlock(), _createElementBlock("div", {
                key: org.org_id,
                class: "w-full"
              }, [
                _createVNode(_component_ChooseCenterCard, {
                  "data-org": org,
                  onSubmit: ($event: any) => (_ctx.selectOrg(org))
                }, null, 8, ["data-org", "onSubmit"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_38
  ]))
}